<div class="upload-content-modal-title">
  <span class="upload-content-modal-title-caption">{{ 'file-manager-upload-content-dialog-title' | xsI18n  }} </span>
  <div class="xs-dialog-close-btn" [soti-tooltip]="'lv-close' | xsI18n" placement="top"
    (click)="cancel()"></div>
</div>
<div class="dialog-header-separator"></div>
<div class="mat-dialog-content">
      <div class="content-row first-row">
        <span class="content-field-title">{{ 'file-manager-upload-content-dialog-description-label' | xsI18n  }}</span>
      </div>
        <div class="content-row">
          <span class="content-field-title">{{ 'file-manager-upload-content-dialog-uploadfilefolder-label' | xsI18n  }}</span>
          <app-browse-filefolder-dragdrop-content [isDragAndDropStyle]="true" [restrictFileSelection]="true" [uploadDescription]="false"
                                                  [isFolderUpload]="true" [hasMultipleFilesSupport]="true" [showLoader]="false" (uploadEvent)="uploadContent($event)"
                                                  (errorMessageEvent)="setErrorMessageOfBrowseFileFolderDropContentComponent($event)">
          </app-browse-filefolder-dragdrop-content>
        </div>
        <div class="content-row align-center">
          <span class="content-field-title">{{ 'file-manager-upload-content-dialog-destination-label' | xsI18n  }}</span>
          <span class="destination-path" sa-ellipsis [fullText]="uploadPath.value"></span>
        </div>
        <div class="content-row align-center">
          <span class="content-field-title">{{ 'file-manager-upload-content-dialog-overwrite-files-label' | xsI18n  }}</span>
          <app-toggle-switch-button [checked]="overWriteFile.value" (change)="toggleOverwriteFiles(overWriteFile)"></app-toggle-switch-button>
        </div>
</div>
<div class="upload-content-dialog-buttons">
  <button class="xs-btn btn-outline btn-space" (click)="cancel()"> {{ 'xs_cancel_label' | xsI18n  }} </button>
  <button class="xs-btn btn-primary" (click)="upload()" [disabled]="!isAnyFiletoUpload"> {{ 'file-manager-upload-content-dialog-upload-button-caption' | xsI18n  }} </button>
</div>
